import { LOCALE_ID, Pipe, inject, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appAdvancedNumber',
  standalone: true,
})
export class AdvancedNumberPipe implements PipeTransform {

  private formatters = new Map<string, Intl.NumberFormat>();
  private locale = inject(LOCALE_ID);

  public transform(value: number,
    notation: 'standard' | 'scientific' | 'engineering' | 'compact' = 'standard',
    style: 'decimal' | 'currency' = 'decimal',
    currencyCode?: string,
    minimumFractionDigits?: number,
    maximumFractionDigits?: number,
    grouping?: 'always' | 'auto' | 'min2' | false,
  ): string {
    const cacheKey = `${notation}:${style}:${currencyCode}`;

    if (!this.formatters.has(cacheKey)) {
      this.formatters.set(cacheKey, new Intl.NumberFormat(this.locale, {
        style: style,
        currency: currencyCode,
        notation: notation,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
        useGrouping: grouping as boolean,
      }))
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.formatters.get(cacheKey)!.format(value);
  }

}
